<template>
  <PublicPopup
    ref="PopupRef"
    title="Notificação de retirada"
    :closeable="false"
    @close="emit('close')"
  >
    <template #content>
      <div class="top-up-popup">
        <div class="header">
          <div class="header__success-icon">
            <van-icon name="success" size="36" color="#FFFFFF" />
          </div>
          <p class="header__label">Saque Bem Sucedido</p>
        </div>

        <div class="field-container">
          <div class="field">
            <span class="field__label">Valor do Saque</span>
            <span class="field__value">
              <span class="field__value--black">{{ dataForm.plan_amount }}</span>
              <span>BRL</span>
            </span>
          </div>
          <div class="field">
            <span class="field__label">Taxa</span>
            <span class="field__value">
              <span class="field__value--black">{{ dataForm.fee }}</span>
              <span>BRL</span>
            </span>
          </div>
          <div class="field">
            <span class="field__label">Chegada real</span>
            <span class="field__value">
              <span class="field__value--black">{{ dataForm.amount }}</span>
              <span>BRL</span>
            </span>
          </div>
          <div class="field">
            <span class="field__label">Sacar para</span>
            <span class="field__value images">
              <van-image
                width="32"
                height="32"
                :src="getImageUrlWithCDN_LOCAL('/deposito/pay-icon.png')"
              />
              <div class="field__value--flex">
                <span class="value">PIX</span>
                <span class="card-number">({{ dataForm.account_info.card_no }})</span>
              </div>
            </span>
          </div>
        </div>

        <div class="btn-view" @click="handlePopupClose">Entendido</div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const dataForm = reactive({
  plan_amount: 100.0,
  fee: 2.0,
  amount: 98.0,
  account_info: {
    bank_name: '-',
    card_no: '-',
    account_name: '-',
  },
})

const PopupRef = ref(null)
const open = (msg) => {
  for (const key in dataForm) {
    const item = msg[key]
    if (item && item !== undefined) {
      dataForm[key] = item
    }
  }

  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="less" scoped>
.top-up-popup {
  padding: 10px;
  width: 300px;

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    &__success-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background-color: var(--special-success-10000);
      border-radius: 50%;
    }

    &__label {
      margin-top: 10px;
      font-weight: 700;
      color: var(--special-success-10000);
    }
  }

  .field-container {
    .field + .field {
      margin-top: 10px;
    }
    .field {
      display: grid;
      grid-template-columns: 120px auto;

      &__label {
        color: var(--top-up-popup-content-label);
      }
      &__value {
        color: var(--top-up-popup-content-label);

        &--black {
          margin-right: 4px;
          color: var(--top-up-popup-content-value);
        }

        &.images {
          display: flex;
          align-items: center;

          .field__value--flex {
            display: inline-flex;
            flex-direction: column;
            margin-left: 8px;

            .value {
              color: var(--top-up-popup-content-value);
            }
            .card-number {
              color: var(--top-up-popup-content-label);
            }
          }
        }
      }
    }
  }

  .btn-view {
    margin-top: 20px;
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: var(--top-up-popup-confirm-bg);
    color: var(--top-up-popup-confirm-text);
    font-size: 14px;
    border-radius: 5px;
  }
}
</style>
